export default "__VITE_ASSET__Ce5IRoRv__"